import UserConsoleLayout from '@/views/kpi/layout/userConsoleLayout.vue';

/**
 * @import {Route} from "./route.jsdoc.js"
 */

/**
 * 财政局用户路由表
 * @type {[Route]}
 */
export const financeRoutes = [
    {
        title: '预算单位管理',
        path: '/enterprise/sys-setting/budget-org-list',
        page: () => import('@/views/kpi/enterprise/my-org-group-child-list/my-org-group-child-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '系统设置', '预算单位管理' ],
        icon: [ 'vxe-icon-setting', '' ],
    },
    {
        path: '/enterprise/sys-setting/partner-org-list',
        page: () => import('@/views/kpi/enterprise/org-partner/my-org-partner-list.vue'),
        layout: [ UserConsoleLayout ],
        title: '合作伙伴管理',
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '系统设置', '合作伙伴管理' ],
        icon: [ 'vxe-icon-setting', '' ],
    },
    {
        title: '审核流程管理',
        path: '/enterprise/sys-setting/audit-flow-cfg',
        page: () => import('@/views/kpi/enterprise/my-org-audit-flow-cfg/my-org-audit-flow-cfg.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '系统设置', '审核流程管理' ],
        icon: [ 'vxe-icon-setting', '' ],
    },
    {
        title: '编辑中绩效申报表',
        path: '/kpi/proj-kpi-audit/draft-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-draft-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '编辑中绩效表' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '待提交审核绩效申报表',
        path: '/kpi/proj-kpi-audit/pre-audit-task-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-no-audit-task-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '待提交审核' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '待审核绩效申报表',
        path: '/kpi/proj-kpi-audit/fina-audit-task-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-waiting-audit-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '待审核' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '项目绩效申报表审核',
        path: '/kpi/proj-kpi-audit/kpi-table-edit/:level/:projId',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/proj-kpi-table-editor.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
    {
        title: '审核中绩效申报表',
        path: '/kpi/proj-kpi-audit/auditing-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-auditing-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '审核中绩效表' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        path: '/kpi/proj-kpi-audit/audited-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/my-org-proj-kpi-audited-list.vue'),
        layout: [ UserConsoleLayout ],
        title: '审核完成绩效申报表',
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '审核完成' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '绩效申报表管理',
        path: '/kpi/proj-kpi-audit/submit-kpi-list',
        page: () => import('@/views/kpi/enterprise/my-org-proj-kpi-list/submit-org-proj-kpi-list.vue'),
        layout: [ UserConsoleLayout ],
        roles: [ 'org-user', 'org-admin', 'org-creator' ],
        requireAuth: true,
        visible: true,
        closable: true,
        menu: [ '绩效申报表管理', '绩效申报表管理' ],
        icon: [ 'vxe-icon-signature', '' ],
    },
    {
        title: '绩效绩效表审核日志',
        path: '/kpi/proj-kpi-audit/proj-audit-log/:projId',
        page: () => import('@/views/kpi/enterprise/proj-kpi-audit-log-list/proj-kpi-audit-log-list.vue'),
        layout: [ UserConsoleLayout ],
        props: true,
        roles: [ 'org-user', 'org-creator', 'org-admin' ],
        requireAuth: true,
        visible: true,
        closable: true,
    },
];
